/*
 * A single ratio against a budget. Same-hue track, per the form heuristic — a
 * pie of two slices would be the wrong shape for this.
 */

interface Props {
  label: string;
  /** Displayed as-is; the caller formats the unit. */
  display: string;
  value: number;
  budget: number;
  lowerIsBetter?: boolean;
  budgetLabel?: string;
}

export function Meter({ label, display, value, budget, lowerIsBetter = true, budgetLabel }: Props) {
  const ratio = budget === 0 ? 0 : value / budget;
  const withinBudget = lowerIsBetter ? value <= budget : value >= budget;
  // Only two states, and both ship with a text label — status color never
  // carries the meaning alone.
  const color = withinBudget ? 'var(--status-good)' : 'var(--status-serious)';
  const pct = Math.min(100, Math.max(2, ratio * 100));

  return (
    <div className="meter">
      <div className="meter__head">
        <span className="meter__label">{label}</span>
        <span className="meter__value">{display}</span>
      </div>
      <div
        className="bar-track"
        role="meter"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={budget}
        aria-label={`${label}: ${display} against a budget of ${budgetLabel ?? budget}`}
      >
        <div className="bar-fill" style={{ width: `${pct}%`, background: color }} />
      </div>
      <span className="meter__foot">
        {withinBudget ? 'Within' : 'Over'} budget · target {budgetLabel ?? budget}
      </span>
    </div>
  );
}
